export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20composition%20with%20smooth%20flowing%20gradients%2C%20warm%20cream%20and%20deep%20charcoal%20tones%2C%20soft%20layered%20organic%20shapes%20intersecting%20with%20architectural%20precision%2C%20no%20text%20or%20people%2C%20elegant%20sophistication%2C%20contemporary%20minimal%20design%2C%20subtle%20texture%20and%20depth%2C%20high%20contrast%20warm%20aesthetic%2C%20smooth%20curves%20with%20clean%20lines&width=1600&height=900&seq=hersa-hero-01&orientation=landscape"
          alt="Abstract geometric background with flowing gradients"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 py-32 text-center">
        <h1 className="animate-fade-in font-heading text-4xl md:text-6xl lg:text-7xl font-light tracking-tight text-white mb-8">
          HERSA MEDIA S.R.L.
        </h1>
        <p className="animate-fade-in-up animation-delay-200 font-heading text-lg md:text-2xl font-light tracking-wide text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          Engineering Excellence for the iOS Platform
        </p>
        <p className="animate-fade-in-up animation-delay-400 text-sm md:text-base font-light text-white/70 max-w-xl mx-auto leading-relaxed">
          A professional engineering team dedicated to designing and developing modern digital software solutions for the iOS platform and related technologies.
        </p>
      </div>
    </section>
  );
}